import React, { useEffect, useState } from "react";
import NewLoader from "../../../../../components/styled-components/loader/NewLoader";
import CreditCardIcon from "../../../../../assets/disabilityIcons/creditCard.svg";
import formatAmount from "../../../../../helpers/formatAmount";
import { setUnsavedChanges } from "../../../../../redux/slices/loginSlice";
import { InputNumber, Slider } from "antd";
import { useDispatch } from "react-redux";
import "./styles/monthlybudget.css";

const SliderComponent = ({
  icon,
  min = 0,
  max = 10000,
  step = 1,
  loading,
  setFormData,
  item,
  activeTab,
}) => {
  const dispatch = useDispatch();
  const [currentValue, setCurrentValue] = useState(
    item.monthlyBudget ? item.monthlyBudget : item.divorceBudgetAmount || min
  );
  const [divorceValue, setDivorceValue] = useState(
    item.postDivorceBudget
      ? item.postDivorceBudget
      : item.divorceBudgetAmount || min
  );

  // Get the appropriate max value based on active tab
  const getMaxValue = () => {
    if (activeTab === "current") {
      const value = item.divorceBudgetAmount || 0;
      return Math.max(value * 3, 10000); // Fixed $10,000 for current budget
    } else {
      const base = item.postDivorceBudget || 0;
      return Math.max(base, 100); // Keep the original calculation for divorce budget
    }
  };
  const [sliderMax, setSliderMax] = useState(getMaxValue());

  // Handle slider change based on active tab
  const handleChange = (e) => {
    e.persist();
    const newValue = Number(e.target.value);

    // Update the slider background position
    // const percent = ((newValue - min) / (getMaxValue() - min)) * 100;
    const percent = Math.min(
      ((newValue - min) / (getMaxValue() - min)) * 100,
      100
    );

    e.target.style.backgroundPosition = `${100 - percent}% bottom`;

    if (activeTab === "current") {
      setCurrentValue(newValue);

      setFormData((prev = []) => {
        const updatedFormData =
          prev !== null &&
          prev.map((entry) =>
            entry.categoryId === item.categoryId
              ? {
                  ...entry,
                  monthlyBudget: newValue,
                  divorceBudgetAmount: newValue,
                }
              : entry
          );

        return prev.some((entry) => entry.categoryId === item.categoryId)
          ? updatedFormData
          : [
              ...prev,
              {
                categoryId: item.categoryId,
                id: item.id,
                monthlyBudget: newValue,
                divorceBudgetAmount: newValue,
              },
            ];
      });
    } else {
      setDivorceValue(newValue);

      setFormData((prev = []) => {
        const updatedFormData =
          prev !== null &&
          prev.map((entry) =>
            entry.categoryId === item.categoryId
              ? { ...entry, postDivorceBudget: newValue }
              : entry
          );

        return prev.some((entry) => entry.categoryId === item.categoryId)
          ? updatedFormData
          : [
              ...prev,
              {
                categoryId: item.categoryId,
                id: item.id,
                postDivorceBudget: newValue,
              },
            ];
      });
    }
  };

  // Accept either an event (from native <input>) or a number (from AntD Slider)
  const handleChangeSlider = (eOrValue) => {
    let newValue;

    if (
      typeof eOrValue === "object" &&
      eOrValue !== null &&
      "target" in eOrValue &&
      eOrValue.target !== null
    ) {
      const e = eOrValue;
      newValue = Number(e.target.value);

      try {
        const percent = Math.min(
          ((newValue - min) / (getMaxValue() - min)) * 100,
          100
        );
        if (e.target && e.target.style) {
          e.target.style.backgroundPosition = `${100 - percent}% bottom`;
        }
      } catch (err) {
        // ignore styling errors (safe fallback)
      }
    } else {
      newValue = Number(eOrValue);
    }

    if (Number.isNaN(newValue)) newValue = min;

    if (activeTab === "current") {
      setCurrentValue(newValue);

      setFormData((prev = []) => {
        const updatedFormData =
          prev !== null &&
          prev.map((entry) =>
            entry.categoryId === item.categoryId
              ? {
                  ...entry,
                  monthlyBudget: newValue,
                  divorceBudgetAmount: newValue,
                }
              : entry
          );

        return prev.some((entry) => entry.categoryId === item.categoryId)
          ? updatedFormData
          : [
              ...prev,
              {
                categoryId: item.categoryId,
                id: item.id,
                monthlyBudget: newValue,
                divorceBudgetAmount: newValue,
              },
            ];
      });
    } else {
      setDivorceValue(newValue);

      setFormData((prev = []) => {
        const updatedFormData =
          prev !== null &&
          prev.map((entry) =>
            entry.categoryId === item.categoryId
              ? { ...entry, postDivorceBudget: newValue }
              : entry
          );

        return prev.some((entry) => entry.categoryId === item.categoryId)
          ? updatedFormData
          : [
              ...prev,
              {
                categoryId: item.categoryId,
                id: item.id,
                postDivorceBudget: newValue,
              },
            ];
      });
    }
    dispatch(setUnsavedChanges(true));
  };

  const handleInputChange = (value, type) => {
    if (value === null || value === undefined) return;

    // Convert to number
    let numericValue = parseFloat(value.toString().replace(/,/g, "")) || 0;

    // Apply min/max limits
    const minValue = min || 0;
    const maxValue = getMaxValue() || Number.MAX_SAFE_INTEGER;
    // numericValue = Math.max(minValue, Math.min(numericValue, maxValue));
    numericValue = Math.max(minValue, numericValue);
    // const sliderValue = Math.min(numericValue, maxValue);
    const sliderValue = numericValue;
    if (numericValue > sliderMax) setSliderMax(numericValue);
    // Update state
    const strValue = numericValue.toFixed(2); // always 2 decimals

    if (type === "current") {
      setCurrentValue(sliderValue); // slider capped at max
      // but save the full numericValue to formData
      setFormData((prev = []) => {
        const updatedFormData = prev.map((entry) =>
          entry.categoryId === item.categoryId
            ? {
                ...entry,
                monthlyBudget: numericValue,
                divorceBudgetAmount: numericValue,
              }
            : entry
        );
        return prev.some((entry) => entry.categoryId === item.categoryId)
          ? updatedFormData
          : [
              ...prev,
              {
                categoryId: item.categoryId,
                id: item.id,
                monthlyBudget: numericValue,
                divorceBudgetAmount: numericValue,
              },
            ];
      });
    } else {
      setDivorceValue(sliderValue);
      setFormData((prev = []) => {
        const updatedFormData = prev.map((entry) =>
          entry.categoryId === item.categoryId
            ? { ...entry, postDivorceBudget: numericValue }
            : entry
        );
        return prev.some((entry) => entry.categoryId === item.categoryId)
          ? updatedFormData
          : [
              ...prev,
              {
                categoryId: item.categoryId,
                id: item.id,
                postDivorceBudget: numericValue,
              },
            ];
      });
    }
    dispatch(setUnsavedChanges(true));
  };

  // Add useEffect to update slider background position on initial render and when values change
  useEffect(() => {
    const sliderElement = document.querySelector(
      `input[name="${item.budgetCategory.categoryName}"]`
    );
    if (sliderElement) {
      const value = activeTab === "current" ? currentValue : divorceValue;
      const max = activeTab === "current" ? 10000 : 3 * item.amount;
      const percent = ((value - min) / (max - min)) * 100;
      sliderElement.style.backgroundPosition = `${100 - percent}% bottom`;
    }
  }, [
    currentValue,
    divorceValue,
    activeTab,
    min,
    item.budgetCategory.categoryName,
    item.amount,
  ]);

  // Update currentValue when item.divorceBudgetAmount changes
  useEffect(() => {
    if (item.divorceBudgetAmount !== undefined) {
      setCurrentValue(item.divorceBudgetAmount || min);
    }
  }, [item.divorceBudgetAmount, min]);

  // Update divorceValue when item.postDivorceBudget changes
  useEffect(() => {
    if (item.postDivorceBudget !== undefined) {
      setDivorceValue(item.postDivorceBudget || min);
    }
  }, [item.postDivorceBudget, min]);

  console.log("reserrrrr", item, currentValue, divorceValue);

  return (
    <div className="slider-component">
      <div className="left-container">
        <div className="icon-container">
          {icon && (
            <img
              src={icon || "/placeholder.svg"}
              alt="icon"
              className="category-icon"
            />
          )}
        </div>
        <div className="icon-description-container">
          <h4 className="icon-description">
            {item.budgetCategory.categoryName}
          </h4>
        </div>
      </div>

      <div className="mid-container">
        <div className="min-max-container">
          <div className="amount-container">
            <p className="amount-title">$0</p>
          </div>
          <div className="max-amount-container">
            <p className="amount-title">${formatAmount(getMaxValue())}</p>
          </div>
        </div>

        <div className="slider-input-container">
          <Slider
            min={min}
            // max={getMaxValue()}
            max={sliderMax}
            name={item.budgetCategory.categoryName}
            step={step}
            value={Number(
              activeTab === "current" ? currentValue : divorceValue
            )}
            onChange={(value) => handleChangeSlider(value)}
            trackStyle={{
              backgroundColor: activeTab === "current" ? "#2a3da3" : "#6b7a99",
              height: 6,
            }}
            handleStyle={{
              borderColor: activeTab === "current" ? "#2a3da3" : "#6b7a99",
              backgroundColor: activeTab === "current" ? "#2a3da3" : "#6b7a99", // 👈 fill color
              width: 20,
              height: 20,
              marginTop: -7,
              boxShadow: "0 0 0 3px rgba(0, 0, 0, 0.1)", // nice subtle glow
            }}
            railStyle={{ backgroundColor: "#E5E7EB", height: 6 }}
          />

          {/* <input
            type="range"
            name={item.budgetCategory.categoryName}
            className={`slider-input ${
              activeTab === "current" ? "current-slider" : "divorce-slider"
            }`}
            min={min}
            max={getMaxValue()}
            step={step}
            value={activeTab === "current" ? currentValue : divorceValue}
            style={{
              "--value": `${Math.min(
                100,
                ((activeTab === "current" ? currentValue : divorceValue) /
                  getMaxValue()) *
                  100
              )}%`,
            }}
            onChange={handleChange}
          /> */}

          {/* Visual indicators for both values */}
          <div className="slider-indicators">
            <div
              className="current-indicator"
              style={{
                // left: `${Math.min(
                //   ((currentValue - min) / (getMaxValue() - min)) * 100,
                //   100
                // )}%`,
                left: `${
                  ((currentValue - min) / (getMaxValue() - min)) * 100
                }%`,
              }}
              title="Current Budget"
            ></div>
            <div
              className="divorce-indicator"
              style={{
                // left: `${
                //   ((divorceValue - min) / (getMaxValue() - min)) * 100
                // }%`,
                left: `${Math.min(
                  ((divorceValue - min) / (getMaxValue() - min)) * 100,
                  100
                )}%`,
              }}
              title="Post Divorce Budget"
            ></div>
          </div>
        </div>
      </div>

      <div className="right-container">
        <div className="budget-values-container">
          <div className="current-budget-container">
            <div className="inputWrapper-create-budget">
              <span
                className="input-dollar-sign"
                style={{ background: "#fff", border: "none" }}
              >
                $
              </span>
              <InputNumber
                step={0.01}
                min={min}
                // max={getMaxValue()}
                value={currentValue}
                formatter={(value) =>
                  value ? `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",") : ""
                }
                parser={(value) => value.replace(/\$\s?|,/g, "")}
                style={{ border: "none", background: "#fff", width: "100%" }}
                className="Input"
                onChange={(value) => handleInputChange(value, "current")}
              />
            </div>
          </div>
          <div className="divorce-budget-container">
            <div className="inputWrapper-create-budget">
              <span
                className="input-dollar-sign"
                style={{ background: "#fff", border: "none" }}
              >
                $
              </span>
              <InputNumber
                step={0.01}
                min={min}
                // max={getMaxValue()}
                value={divorceValue}
                formatter={(value) =>
                  value ? `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",") : ""
                }
                parser={(value) => value.replace(/\$\s?|,/g, "")}
                style={{ border: "none", background: "#fff", width: "100%" }}
                className="Input"
                onChange={(value) => handleInputChange(value, "divorce")}
              />
            </div>
          </div>
        </div>
      </div>
      <NewLoader isLoading={loading} />
    </div>
  );
};
const SlidersContainer = ({ setFormData, budgetData, resetBudgetData }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("current"); // "current" or "divorce"
  const [formattedData, setFormattedData] = useState([]);
  const formatBudgetData = () => {
    if (!formattedData) return [];
    return formattedData.map((item) => ({
      categoryId: item.categoryId,
      id: item.id,
      monthlyBudget: item.amount || 0,
      divorceBudgetAmount: item.amount || 0,
    }));
  };

  useEffect(() => {
    if (budgetData) {
      setFormattedData(budgetData);
    }
  }, [budgetData]);

  return (
    <div className="budget-container-wrapper">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "1rem",
        }}
      >
        <div className="budget-toggle-container">
          <div
            className={`toggle-button-container ${
              activeTab === "current" ? "active" : ""
            }`}
          >
            <button
              className={`toggle-button ${
                activeTab === "current" ? "active" : ""
              }`}
              onClick={() => setActiveTab("current")}
            >
              Current Monthly Budget
            </button>
          </div>
          <div
            className={`toggle-button-container ${
              activeTab === "divorce" ? "active" : ""
            }`}
          >
            <button
              className={`toggle-button ${
                activeTab === "divorce" ? "active" : ""
              }`}
              onClick={() => setActiveTab("divorce")}
            >
              Post Divorce Budget
            </button>
          </div>
        </div>
        <button
          className="submit-button"
          onClick={async () => {
            const formateData = formatBudgetData();
            await resetBudgetData(formateData);
            dispatch(setUnsavedChanges(false));
          }}
        >
          Reset to Default
        </button>
      </div>
      <div className="budget-headers">
        <div className="budget-header-left"></div>
        <div className="budget-header-mid"></div>
        <div className="budget-header-right">
          <div className="current-budget-header">Current Budget</div>
          <div className="post-divorce-header">Post Divorce Budget</div>
        </div>
      </div>

      <div className="sliders-container">
        {formattedData &&
          formattedData.map((item, index) => (
            <SliderComponent
              key={index}
              icon={CreditCardIcon}
              item={item}
              min={0}
              step={1}
              loading={loading}
              setFormData={setFormData}
              activeTab={activeTab}
            />
          ))}
        <NewLoader isLoading={loading} />
      </div>
    </div>
  );
};

export default SlidersContainer;
